import {Component} from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
   selector: 'app-confirm-dialog',
   templateUrl: './confirm-dialog.component.html',
   styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent {
   public disableSignButton = false;
   public isConfirm = false;
   public isSignOff = false;
   public isResend = false;
   public isSaved = false;
   public isSubmit = false;
   public isShowInfo = false;
   public isMsg = false;
   public str = '';
   shareOutList: any[] = [];
   messageWarning: string;
   messageBtnOK: string;
   messageInfo: string;

   constructor(private dialogRef: MatDialogRef<ConfirmDialogComponent>) {
   }

   ok() {
      this.dialogRef.close(true);
      this.str = 'ok';
   }
   cancel() {
      this.dialogRef.close(false);
      this.str = 'cancel';

   }
   notSave() {
      this.dialogRef.close(true);
      this.str = 'notSave';
   }

}
